// Keep the full service catalogue for historical tickets and booking labels.
// This is a panel choice policy, not a backend retirement rule.
export const SERVICE_CHOICE_MESSAGE = 'Please select an available service type. R is no longer available for new tickets or transfers.'

export function selectableServiceTypes(services = []) {
  return services.filter(service => service.prefix !== 'R')
}

export function canSelectServiceType(services = [], id) {
  if (id === null || id === undefined || id === '') return false
  return selectableServiceTypes(services).some(service => String(service.service_type_id) === String(id))
}

export function isRetiredServiceType(services = [], id) {
  return services.some(service => String(service.service_type_id) === String(id) && service.prefix === 'R')
}
